import { OptionNumType, ProviderCategory, ProviderType } from '../../../types';
import { getData } from '../../../utils/service';
import { PROVIDER_CATEGORIES_ROUTE, PROVIDER_DETAILS_ROUTE, PROVIDER_TYPES_ROUTE } from './routes';

export { PROVIDER_CATEGORIES_ROUTE, PROVIDER_DETAILS_ROUTE, PROVIDER_TYPES_ROUTE };

export const loadTypeOptions = async (categoryId: number) => {
  const data = await getData<ProviderType[]>('providerTypes', {
    pathParams: { provider_category_id: categoryId ? `/${categoryId}` : '' },
  });
  return data.map((item: ProviderType) => ({
    value: item.id,
    label: item.providerTypeCode,
  }));
};

// [MCV-1556] `loadOptions` is called by react-select as `loadOptions(inputValue,
// callback)` on every keystroke, but this took no arguments, so it discarded
// the typed term and returned the full list every time -- the "Provider
// Category" select looked searchable but typing filtered nothing. `inputValue`
// is optional so the existing zero-arg callers (e.g. defaultOptions="true"
// mount loads) remain valid; AsyncSelect's default `filterOption` narrows
// client-side too, but filtering here as well keeps this loader correct even
// if a future caller opts out of that via the escape hatch.
export const loadCategoryOptions = async (inputValue?: string): Promise<OptionNumType[]> => {
  const data = await getData<ProviderCategory[]>('providerCategories');
  const options = data.map((item: ProviderCategory) => ({
    value: item.id,
    label: item.providerCategoryCode,
  }));
  if (!inputValue) {
    return options;
  }
  const term = inputValue.toLowerCase();
  return options.filter((option) => option.label.toLowerCase().includes(term));
};
